import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertController, IonicModule, PopoverController} from '@ionic/angular';
import {AuthService, KioskService} from 'src/app/services';
import {NetworkService, ConnectionStatus} from 'src/app/services/network.service';

@Component({
  selector: 'app-settings-menu',
  templateUrl: 'settings-menu.component.html',
  styleUrls: ['settings-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class SettingsMenuComponent {
  subjectId: string;

  constructor(
    private readonly alert: AlertController,
    private readonly popover: PopoverController,
    private readonly auth: AuthService,
    private readonly network: NetworkService,
    private readonly kiosk: KioskService,
  ) {
    this.subjectId = this.auth.subjectId;
  }

  get isSignedIn(): boolean {
    return this.auth.isSignedIn$.value;
  }

  get isKioskMode(): boolean {
    return this.kiosk.isKioskMode$.value;
  }

  menuChoice(action: string): void {
    const nav = action.startsWith('nav:') ? action.substring(4) : undefined;
    this.popover.dismiss({nav}).then();

    if (!nav) {
      switch (action) {
        case 'copy-kiosk-users':
          this.kiosk.confirmCopyUsers().then();
          break;
        case 'add-kiosk-user':
          this.addKioskUser();
          break;
        case 'toggle-manual-mode':
          this.toggleManualMode();
          break;
        default:
          console.log('action not supported: ', action);
          this.alert.create({
            header: 'Menu Action',
            message: `'Menu Action ${action}' not supported. Please contact support.`,
            buttons: [
              {
                text: 'Okay',
                handler: () => {
                },
              },
            ],
          }).then();
      }
    }
  }

  get manualOffline(): boolean {
    return this.network.manualMode === ConnectionStatus.Offline;
  }

  toggleManualMode(): void {
    const mode = this.network.manualMode;
    if (mode === ConnectionStatus.Online) {
      this.alert
        .create({
          header: 'Work Offline',
          message: `Are you sure you want to work offline?<br/><b>Note: Your punches will not be sent to the server until you come back online.</b>`,
          backdropDismiss: false,
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
              },
            },
            {
              text: 'Okay',
              handler: () => {
                this.network.manualMode = ConnectionStatus.Offline;
              },
            },
          ],
        })
        .then((alert) => alert.present());
    } else {
      this.network.manualMode = ConnectionStatus.Online;
    }
  }

  addKioskUser(): void {
    this.kiosk.ensureKioskMode();
    this.auth.signIn();
  }
}
